import React, { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { pushFormSubmitEvent, FORM_NAME_CONTACT_SALES } from "../../utils/datalayer"

declare global {
  interface Window {
    ss_form: any
  }
}

const SharpSpringFormContact: React.FC = () => {
  const externalScript = useRef<HTMLScriptElement | null>(null)
  const location = useLocation()

  const loadScript = () => {
    window.ss_form = {
      account: "MzawMLEwNDM2BgA",
      formID: "M0w0MjVLNjDStTBISdY1STNJ1k0yS7TUtUhLTDK2TEtKTTQwBgA",
      width: "100%",
      domain: "app-3QNMBY6FU6.marketingautomation.services",
      target_id: "form",
      polling: true,
    }

    if (externalScript.current) document.body.removeChild(externalScript.current)
    externalScript.current = document.createElement("script")
    externalScript.current.src = "https://koi-3QNMBY6FU6.marketingautomation.services/client/form.js?ver=2.0.1"
    externalScript.current.async = true
    document.body.appendChild(externalScript.current)

    const messageHandler = function (event: any) {
      if (event.data === "Form submitted") {
        pushFormSubmitEvent(FORM_NAME_CONTACT_SALES)
      }
    }
    window.addEventListener("message", messageHandler)

    return () => {
      window.onload = null
      window.removeEventListener("message", messageHandler)
      if (externalScript.current) document.body.removeChild(externalScript.current)
    }
  }

  useEffect(() => {
    // window on load
    window.onload = () => {
      loadScript()
    }
    return () => {
      window.onload = null
      if (externalScript.current) document.body.removeChild(externalScript.current)
    }
  }, [])

  useEffect(() => {
    loadScript()
  }, [location])

  return (
    <main>
      <div id="form"> </div>
    </main>
  )
}

export default SharpSpringFormContact
